import { CurrencyPipe, DecimalPipe, NgClass, NgTemplateOutlet, SlicePipe, UpperCasePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Field } from '@zero/instrument-details/domain';
import { HeaderBase } from '@zero/instrument-details/feature-instrument-details/base';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { BigNumbersPipe, TodayTimeOrDatePipe } from '@zero/shared/ui-pipes';
import { WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { CopyToClipboardComponent, DividerComponent, IconButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';
import { PushAlertModalComponent } from '../push-alert-modal/push-alert-modal.component';

@Component({
  selector: 'instrument-details-instrument-header',
  templateUrl: './header-web.component.html',
  styleUrls: ['./header-web.component.scss'],
  imports: [
    NgTemplateOutlet,
    BlinkDirective,
    CopyToClipboardComponent,
    RouterLink,
    WatchlistToggleComponent,
    PushAlertModalComponent,
    SlicePipe,
    DecimalPipe,
    CurrencyPipe,
    BigNumbersPipe,
    TranslocoPipe,
    NgbTooltipModule,
    IconComponent,
    DividerComponent,
    TodayTimeOrDatePipe,
    IconButtonComponent,
    UpperCasePipe,
    IconComponent,
    NgClass,
  ],
})
export class HeaderWebComponent extends HeaderBase implements OnInit, OnChanges {
  @ViewChild('pushAlertModal') public pushAlertModal?: TemplateRef<HTMLElement>;

  public bigQuoteThreshold = 1000;

  public readonly tradeCreateForm = commonRoutes.postlogin.buyAndSell;
  public readonly savingsPlanForm = commonRoutes.postlogin.add_savings_plan;
  public readonly instrumentDetail = commonRoutes.postlogin.instrument_detail;
  readonly #ngbModal = inject(NgbModal);

  @Input() public derivativeTopData: Field[];

  public ngOnInit(): void {
    this.#setFormatting();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!changes['model']?.previousValue) {
      this.#setFormatting();
    }
  }

  public openPushAlertModal(): void {
    this.#ngbModal.open(this.pushAlertModal, { centered: true, modalDialogClass: 'push-alert-modal' });
  }

  #setFormatting = (): void => {
    this.setQuoteFormat();
    this.#setBigQuoteThreshold();
  };

  #setBigQuoteThreshold = (): void => {
    if (this.model?.priceScale) {
      this.bigQuoteThreshold = 1000 * (1 / Math.pow(10, this.model.priceScale - 2));
    }
  };
}
